import { analytics } from '../../utils/analytics';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';
type response = {
  status: string;
};

export const updatePracticeById = async (
  id?: string | null,
  body?: object
): Promise<{
  data: response;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  if (!id) {
    throw new Error('Practice ID is not available');
  }
  if (!body) {
    throw new Error('Body is not available');
  }
  const url = `resourceMatrix/practices/update?customerId=${customer}&practiceId=${id}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const data = responseData as response;
    loading = false;
    analytics.trackEvent('update', 'practice');
    return { data, loading };
  } catch (error) {
    loading = false;
    throw error;
  }
};
